define("checkout/components/checkout-button", ["exports", "@ember/component", "@ember/template-factory", "@ember/service", "@glimmer/component"], function (_exports, _component, _templateFactory, _service, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if (or @hasActiveSubscription @hasActiveTrial)}}
    <Shared::Ui::Button
      @additional="block"
      @isDisabled={{not this.changePlanButtonEnabled}}
      @onClick={{perform @onChangePlan}}
      @size="large"
      @variant="none"
      class="tCH--btn--primary qa--update_plan"
      data-test-id="change-plan"
      ...attributes
    >
      {{#if this.isSeamlessCheckoutInProgress}}
        {{svg-jar "refresh" class="o--icon tCH--btn--primaryIcon"}}
      {{/if}}
      {{this.buttonText}}
  
    </Shared::Ui::Button>
  {{else}}
    <Shared::Ui::Button
      @additional="block"
      @isDisabled={{this.checkoutButtonDisabled}}
      @onClick={{perform @onCheckout}}
      @size="large"
      @variant="none"
      class="tCH--btn--primary qa--update_plan"
      data-test-id="purchase"
      ...attributes
    >
      {{#if this.isSeamlessCheckoutInProgress}}
        {{svg-jar "refresh" class="o--icon tCH--btn--primaryIcon"}}
      {{/if}}
      {{this.buttonText}}
    </Shared::Ui::Button>
  {{/if}}
  */
  {
    "id": "apawRgtQ",
    "block": "[[[41,[28,[37,1],[[30,1],[30,2]],null],[[[1,\"  \"],[8,[39,2],[[24,0,\"tCH--btn--primary qa--update_plan\"],[24,\"data-test-id\",\"change-plan\"],[17,3]],[[\"@additional\",\"@isDisabled\",\"@onClick\",\"@size\",\"@variant\"],[\"block\",[28,[37,3],[[30,0,[\"changePlanButtonEnabled\"]]],null],[28,[37,4],[[30,4]],null],\"large\",\"none\"]],[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"isSeamlessCheckoutInProgress\"]],[[[1,\"      \"],[1,[28,[35,5],[\"refresh\"],[[\"class\"],[\"o--icon tCH--btn--primaryIcon\"]]]],[1,\"\\n\"]],[]],null],[1,\"    \"],[1,[30,0,[\"buttonText\"]]],[1,\"\\n\\n  \"]],[]]]]],[1,\"\\n\"]],[]],[[[1,\"  \"],[8,[39,2],[[24,0,\"tCH--btn--primary qa--update_plan\"],[24,\"data-test-id\",\"purchase\"],[17,3]],[[\"@additional\",\"@isDisabled\",\"@onClick\",\"@size\",\"@variant\"],[\"block\",[30,0,[\"checkoutButtonDisabled\"]],[28,[37,4],[[30,5]],null],\"large\",\"none\"]],[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"isSeamlessCheckoutInProgress\"]],[[[1,\"      \"],[1,[28,[35,5],[\"refresh\"],[[\"class\"],[\"o--icon tCH--btn--primaryIcon\"]]]],[1,\"\\n\"]],[]],null],[1,\"    \"],[1,[30,0,[\"buttonText\"]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[]]]],[\"@hasActiveSubscription\",\"@hasActiveTrial\",\"&attrs\",\"@onChangePlan\",\"@onCheckout\"],false,[\"if\",\"or\",\"shared/ui/button\",\"not\",\"perform\",\"svg-jar\"]]",
    "moduleName": "checkout/components/checkout-button.hbs",
    "isStrictMode": false
  });

  let CheckoutButtonComponent = (_class = class CheckoutButtonComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args); // Setting here to avoid reactive updates after checkout is processed but before seamless checkout modal closes

      _initializerDefineProperty(this, "intl", _descriptor, this);

      _initializerDefineProperty(this, "seamlessCheckoutManager", _descriptor2, this);

      _defineProperty(this, "isTrialCheckout", void 0);

      _defineProperty(this, "hasSubscriptionBeforeCheckout", void 0);

      this.isTrialCheckout = this.args.hasActiveTrial || this.args.isEligibleForTrial;
      this.hasSubscriptionBeforeCheckout = this.args.hasActiveSubscription || this.args.hasActiveTrial;
    }

    get buttonText() {
      if (this.isSeamlessCheckoutInProgress) {
        return this.isTrialCheckout ? this.intl.t('plans.checkout.plan.button_in_progress_trial') : this.intl.t('plans.checkout.plan.button_in_progress');
      }

      if (this.hasSubscriptionBeforeCheckout) {
        return this.isTrialCheckout ? this.intl.t('plans.checkout.plan.button_change_plan_trial') : this.intl.t('plans.checkout.plan.button_change_plan');
      }

      return this.isTrialCheckout ? this.intl.t('plans.checkout.plan.button_checkout_trial') : this.intl.t('plans.checkout.plan.button_checkout');
    }

    get isSeamlessCheckoutInProgress() {
      return this.seamlessCheckoutManager.isCheckoutInProgress;
    }

    get hasIncompleteNewCard() {
      return !this.args.cardState?.complete || this.args.cardState?.error;
    }

    get hasCheckoutChanges() {
      return !this.args.isSamePlan || !this.args.isSameInterval || this.args.hasAddonChange;
    }

    get checkoutButtonDisabled() {
      return this.hasIncompleteNewCard || !this.args.hasCompleteAddress || !this.hasCheckoutChanges || this.args.onCheckout.isRunning || this.args.onCheckout.last?.isSuccessful || this.args.hasAgencyPlanCheckoutRestrictions;
    }

    get changePlanButtonEnabled() {
      if (this.args.onChangePlan.isRunning || this.args.onChangePlan.last?.isSuccessful || this.args.onChangeCard.isRunning || !this.args.hasCompleteAddress || this.args.hasAgencyPlanCheckoutRestrictions || this.isOnAutoTrialWithoutNewOrSavedCreditCard) {
        return false;
      }

      return this.hasCheckoutChanges || this.canReactivate;
    }

    get isOnAutoTrialWithoutNewOrSavedCreditCard() {
      return this.args.isOnCardlessTrial && (this.hasIncompleteNewCard || !this.args.hasCompleteAddress) && !this.args.savedStripeCard;
    }

    get canReactivate() {
      return this.args.hasActiveCancelledSubscription;
    } // Note: show if @showMissingInfoMessage true or not passed in at all.


    get shouldShowMissingInfo() {
      const argIsTrueOrEmpty = this.args.showMissingInfoMesage ?? true;
      return argIsTrueOrEmpty && (this.hasIncompleteNewCard || !this.args.hasCompleteAddress);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "seamlessCheckoutManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  _exports.default = CheckoutButtonComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, CheckoutButtonComponent);
});